module.exports = __webpack_public_path__ + "img/Indonesia.8aafdfe0.gif";